import { InjectionToken } from '@angular/core';
import { CacheService } from '../services/cacheInterface';
import { AdyenRedirectParameters } from '~app/modules/checkout/models/adyen-redirect-parameters.model';

export const CACHE_SERVICE = new InjectionToken<CacheService>('CacheService');
export const SSRLOGGER = new InjectionToken<any>('SSRLogger');
export const OriginalQuery = new InjectionToken<any>('OriginalQuery');
export const AdyenRedirectParams = new InjectionToken<AdyenRedirectParameters>('AdyenRedirectParams');
